import { Link } from 'react-router-dom'

import { ColumnType } from '@components/Table/interface'
import { EyeIcon } from '@components/Icons'
import { abbreviateNumber } from '@libs/utils'
import { BookEnum, bookTypeValue } from '@interfaces/BookEnum'
import { BookByTitleType } from '@models/dashboard/BookByTitleType'

export const columns: ColumnType<BookByTitleType>[] = [
  {
    column: 'ปก',
    accessor: 'coverImgPath',
    cell: ({ value }) =>
      value ? (
        <img
          className='w-[29px] h-[41px] object-cover shrink-0'
          src={value}
          alt='cover'
        />
      ) : (
        <div className='w-[29px] h-[41px] bg-gray object-cover shrink-0' />
      ),
    isSortable: false,
    cellClassName: 'pr-[5px]',
  },
  {
    column: 'เรื่อง',
    accessor: 'title',
    cell: ({ value }) => <p className='w-[115px] line-clamp-1'>{value}</p>,
    isSortable: false,
  },
  {
    column: 'ประเภท',
    accessor: 'bookType',
    cell: ({ value }) => <p>{bookTypeValue[value as BookEnum]}</p>,
    cellClassName: 'w-[100px] max-w-[100px] pr-[5px]',
    isSortable: false,
  },
  {
    column: 'Penname',
    accessor: 'penName.firstPenName',
    cell: ({ value }) => <p className='line-clamp-1'>{value}</p>,
    cellClassName: 'w-[170px] max-w-[170px] pr-[5px]',
    isSortable: false,
  },
  {
    column: 'จำนวนตอน',
    accessor: 'chapterCount',
    cell: ({ value }) => <p>{value ? value.toLocaleString() : '-'}</p>,
    cellClassName: 'w-[100px] max-w-[100px] pr-[5px]',
    isSortable: false,
  },
  {
    column: 'View',
    accessor: 'totalRead',
    cell: ({ value }) => <p>{abbreviateNumber(value || 0)}</p>,
    cellClassName: 'w-[100px] max-w-[100px] pr-[5px]',
    isSortable: false,
  },
  {
    column: 'Love',
    accessor: 'totalLike',
    cell: ({ value }) => <p>{abbreviateNumber(value || 0)}</p>,
    cellClassName: 'w-[100px] max-w-[100px] pr-[5px]',
    isSortable: false,
  },
  {
    column: 'ยอดขาย',
    accessor: 'totalSales',
    cell: ({ value }) => <p>{abbreviateNumber(value || 0)}</p>,
    cellClassName: 'w-[100px] max-w-[100px] pr-[5px]',
    isSortable: false,
  },
  {
    column: 'Action',
    accessor: 'id',
    cell: ({ value }) => (
      <div className='flex gap-x-[10px]'>
        <Link to={`/story-detail/${value}`}>
          <button
            className='border border-gray h-[30px] px-[4px] rounded-[8px]'
            type='button'
          >
            <EyeIcon className='text-black-970' width='18' height='18' />
          </button>
        </Link>
      </div>
    ),
    isSortable: false,
  },
]
